const scene = "session/";

export const UPDATE_SESSION = `${scene}UPDATE_SESSION`;
export const UPDATE_FILTER = `${scene}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${scene}UPDATE_REDUCER`;
